<template>
  <div>
    <main-layout :ResizeCallback="resize">
      <div class="reportContainer" v-bind:style="{height: this.reportHeight + 'px'}">
        <div style="height:100%">
          <iframe id="report_iframe" ref="report_iframe" :src="url" @load="iframe_loaded" frameborder="0" allowtransparency="true"
            marginheight="0" marginwidth="0" scrolling="no"></iframe>
            <div ref="hiddenDiv" style="display:none"></div>
        </div>
      </div>
    </main-layout>
  </div>
</template>
<style scoped>
  .reportContainer {
    font-family: "HelveticaNeue";
    position: relative;
    padding: 3px 5px 0px 5px;
    margin-left: auto;
    margin-right: auto;
    min-width: 1024px;
  }
  
  .reportContainer iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
</style>
<script>
import MainLayout from "../components/MainLayout.vue";
import config from "../../config";
import * as api from "../api";

export default {
  data() {
    return {
      url: "",
      reportHeight: this.getSize(),
      clockInt: 0
    };
  },
  created: function() {
    document.body.scrollTop = 0;
    if (this.$store.state.accessToken !== "") {
      let urlTemplate =
        config.get("SSRSServer") + "/ReportServer/Pages/ReportViewer.aspx?@@&rs:embed=true"
      this.url = urlTemplate.replace("@@", this.$store.state.route.query.path)
    }
  },
  methods: {
    getSize: function() {
      return window.innerHeight - 168;
    },
    resize: function() {
      let height = this.getSize();
      this.reportHeight = height <= 250 ? 250 : height;
    },
    iframe_loaded: function(){
      var _self = this
      var iframe = this.$refs.report_iframe
      var idocument = iframe.contentWindow.document
      var btnReport = idocument.getElementById('ReportViewerControl_ctl04_ctl00')
      var hidden = false
      _self.clockInt = setInterval(() => {
        var toolbar = idocument.getElementById('ReportViewerControl_ctl05')
        if(toolbar != null){
          var exportbtn = idocument.getElementsByClassName('ToolbarExport')[0]
          console.log(exportbtn)
          _self.$refs.hiddenDiv.append(exportbtn)
          window.clearInterval(_self.clockInt)
        }
      }, 30)
    }
  },
  mounted: function() {
    let _self = this;
    let path = this.$store.state.route.query.path;
    let reportName = path.substring(path.lastIndexOf("/") + 1);
    if (typeof zE != "undefined") {
      zE.setHelpCenterSuggestions({ labels: [reportName] });
    }
    if (this.$store.state.accessToken !== "") {
      api.getReport(path).then(
        response => {},
        response => {
          console.log(response);
        }
      );
    }
  },
  components: {
    MainLayout
  }
};
</script>


// WEBPACK FOOTER //
// Report.vue?61c13c64